
import * as THREE from 'three'
import References from '@/singletons/references'
import MaterialCreateService from '@/services/Three/material-create.service'
import { useStore } from '@/store'
import { defineComponent } from 'vue'
import { computed, watch } from 'vue'
import TextureLoadService from '@/services/Three/texture-load.service'
import SentrySingleton from '@/singletons/sentry-singleton'

export default defineComponent({
  name: 'RandselMetal',
  setup() {
    const store = useStore()
    const isBagLoaded = computed(() => store.getters.isBagLoaded)

    let materialCreateService: MaterialCreateService
    let textureLoadService: TextureLoadService

    // prettier-ignore
    watch(() => isBagLoaded.value, (_) => {
      try {
        materialCreateService = new MaterialCreateService()
        textureLoadService = new TextureLoadService(References.instance.getSceneReferences().maxAnisotropy)
        let mat = References.instance.getBagReferences().metal.material as THREE.MeshStandardMaterial
        mat.roughness = 0.2;
        mat.metalness = 0.75;
        textureLoadService.loadImage('default/metal', (tex: THREE.Texture | null) => {
          tex!.encoding = THREE.sRGBEncoding;
          mat.map = tex
          mat.needsUpdate = true;
        })
        mat.color = materialCreateService.createColor(0xFFFFFF);
        // mat.envMap = reflectionCube;
        // mat.envMapIntensity = 1;
        mat.dithering = true;

        const ribbon = References.instance.getBagReferences().bag.getObjectByName("05_Ribbon_MetalFittings");
        if (ribbon) {
          (ribbon as THREE.Mesh).material = mat;
        } else {
          console.warn("Mesh with name '05_Ribbon' not found in the scene.");
        }
      }
      catch (err) {
        SentrySingleton.instance.captureException(err)
      }
    }
    )

    return {
      isBagLoaded
    }
  }
})
